import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-arrow-right-green.png'


const _withScopeId = n => (_pushScopeId("data-v-7006bf88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-oc-list" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = {
  key: 1,
  class: "box-list"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "name" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

import { onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { Collection } from '@/stores';
  import { request } from '@/utils';
  import { useRouter, useRoute } from 'vue-router';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();

  const store = Collection.create<Collection>({
    fetch(params = {}) {
      return request.get('/mine/offline_collections', { params: { ...params, page: route.query.page } });
    }
  });

  onMounted(() => {
    store.fetchData();
  });

  const router = useRouter();
  const route = useRoute();
  const handlePageChange = (page: any) => {
    router.replace({ query: { ...route.query, page } });
  };

return (_ctx: any,_cache: any) => {
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppPagination = _resolveComponent("AppPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('Incentive Campaign List')), 1),
    (_unref(store).isEmpty)
      ? (_openBlock(), _createBlock(_component_AppEmptyView, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).data, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "item-card"
            }, [
              _createElementVNode("img", {
                src: item.image?.url,
                class: "image"
              }, null, 8, _hoisted_4),
              _createElementVNode("span", _hoisted_5, _toDisplayString(item.name), 1),
              _createVNode(_component_router_link, {
                to: { name: 'mine.offline_collections.detail', params: { id: item.id } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Detail')) + " ", 1),
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ])),
    (_unref(store).meta.total_pages > 1)
      ? (_openBlock(), _createBlock(_component_AppPagination, {
          key: 2,
          total: _unref(store).meta.total,
          "per-page": _unref(store).meta.per_page,
          page: _unref(store).meta.page,
          onChange: handlePageChange
        }, null, 8, ["total", "per-page", "page"]))
      : _createCommentVNode("", true)
  ]))
}
}

})